const ACCESS_TOKEN = "access_token"

export const LOCAL_STORAGE_KEY = {
    ACCESS_TOKEN
}